import { TuitionFeePeriod } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    periods: [],
    period: {},
    loading: false,
    typeGroup: '',
    totalFee: null,
    loadingFee: false,
  },
  actions: {
    async fetchPeriods({ commit, state }) {
      state.loading = true
      let periods = await TuitionFeePeriod.fetch({ _limit: -1 })
      commit('setPeriods', periods)
      state.loading = false
    },
    async fetchPeriod({ state, commit }, id) {
      state.loading = true
      let period = await TuitionFeePeriod.fetchOne(id)
      commit('changeState', { period })
      state.loading = false
    },
    async updatePeriod({ state, commit }, payload) {
      state.loading = true
      let period = await TuitionFeePeriod.update(payload.id, payload.data)
      commit('changeState', { period })
      state.loading = false
    },
    async reSummary({ state, commit }, { status, type, typeId, id, generatedBy, data }) {
      state.loading = true
      const updateParams = { status, type, typeId, generatedBy }
      if (type === 'specific') {
        delete updateParams.typeId
        updateParams['data'] = data
      }
      let period = await TuitionFeePeriod.update(id, updateParams)
      commit('changeState', {
        period,
        typeGroup: type,
      })
      state.loading = false
    },
    async searchPeriod({ state, commit }, params) {
      state.loading = true
      let searchPeriods = await TuitionFeePeriod.search(params)
      commit('changeState', { periods: searchPeriods })
      state.loading = false
    },
    async getTotalFee({ state, commit, rootState }, params) {
      state.loadingFee = true
      let totalFee
      if (!params.student) {
        totalFee = await TuitionFeePeriod.totalFee(params)
      } else {
        let report = rootState.tuitionFeeReport.report ? rootState.tuitionFeeReport.report : 0
        totalFee = report.totalSumFee - report.totalMinusFee
      }
      commit('changeState', { totalFee })
      state.loadingFee = false
    },
    setLoadingFee({ state, commit }, data) {
      state.loadingFee = data
      commit('changeState', { loadingFee: data })
    },
    setTotalFeeNull({ commit }) {
      commit('changeState', {
        totalFee: 0,
      })
    },
  },
  mutations: {
    resetDataPeriod(state) {
      state.period = {}
      state.periods = []
    },
    setPeriods(state, periods) {
      state.periods = periods
    },
  },
  getters: {
    detailPeriod(state) {
      return state.period
    },
    periods(state) {
      return state.periods
    },
    loading(state) {
      return state.loading
    },
    totalFeeMoney(state) {
      return state.totalFee
    },
    loadingFeeMoney(state) {
      return state.loadingFee
    },
  },
}
